import styled from 'styled-components';

export const CancelButton = styled.div`
  color: ${({ theme }) => theme.colors.palette.systemPinkHover};
  text-decoration: underline;
`;
